<template>
  <footer>
    <section class="section-footer-nav">
      <div class="nagase-footer-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 order-2 order-md-1">
            <div class="row">
              <div class="col-12 col-md-4">
                <ul>
                  <li class="heading d-flex justify-content-between">
                    <div>About us</div>
                    <div
                      class="d-block d-md-none fs-2 cursor-pointer"
                      @click="showFooterAbout = !showFooterAbout"
                    >
                      {{ showFooterAbout ? "-" : "+" }}
                    </div>
                  </li>

                  <template v-if="!showFooterAbout">
                    <li class="d-none d-md-block">
                      <nuxt-link to="/about-nagase">NAGASE Plastic</nuxt-link>
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/automotive-and-e-mobility"
                        >Automotive and E-mobility</a
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/electrical-electronics"
                        >Electrical & Electronics</a
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/office-automation"
                        >Office Automation</a
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/home-appliances">Home Appliances</a>
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/medical-devices">Medical Devices</a>
                    </li>
                    <li class="d-none d-md-block">
                      <a href="/industries/infrastructure">Infrastructure</a>
                    </li>

                    <li class="d-none d-md-block">
                      <nuxt-link to="/use-cases">Use cases</nuxt-link>
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/sustainability">Sustainability</nuxt-link>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <nuxt-link to="/about-nagase">NAGASE Plastic</nuxt-link>
                    </li>
                    <li>
                      <nuxt-link to="/industries/automotive-and-e-mobility"
                        >Automotive and E-mobility</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/electrical-electronics"
                        >Electrical & Electronics</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/office-automation"
                        >Office Automation</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/home-appliances"
                        >Home Appliances</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/medical-devices"
                        >Medical Devices</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/infrastructure"
                        >Infrastructure</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/use-cases"
                        >Use cases</nuxt-link
                      >
                    </li>
                    <li>
                      <nuxt-link to="/industries/sustainability"
                        >Sustainability</nuxt-link
                      >
                    </li>
                  </template>
                  <hr class="pb-0 d-block d-md-none" />
                </ul>
              </div>
              <div class="col-12 col-md-4">
                <ul>
                  <li class="heading d-flex justify-content-between">
                    <div>Products & Services</div>
                    <div
                      class="d-block d-md-none fs-2 cursor-pointer"
                      @click="
                        showFooterProductService = !showFooterProductService
                      "
                    >
                      {{ showFooterProductService ? "-" : "+" }}
                    </div>
                  </li>

                  <template v-if="!showFooterProductService">
                    <li class="d-none d-md-block">
                      <nuxt-link to="/products/high-performance-plastics"
                        >High Performance Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/products/sustainable-plastics"
                        >Sustainable Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/products/engineering-plastics"
                        >Engineering Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/products/commodity-plastics"
                        >Commodity Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link
                        to="/services/material-selection-products-development-support"
                        >Material Selection & Products Development
                        Support</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link
                        to="/services/co2-calculation-visualization-service-by-zero-board"
                        >CO2 Calculation & Visualization Service by Zero
                        Board</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/services/technical-troubleshooting"
                        >Technical Troubleshooting</nuxt-link
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/services/logistics-supports"
                        >Logistics Supports</nuxt-link
                      >
                    </li>
                  </template>
                  <template v-else>
                    <li class="d-md-block">
                      <nuxt-link to="/products/high-performance-plastics"
                        >High Performance Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/products/sustainable-plastics"
                        >Sustainable Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/products/engineering-plastics"
                        >Engineering Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/products/commodity-plastics"
                        >Commodity Plastics</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link
                        to="/services/material-selection-products-development-support"
                        >Material Selection & Products Development
                        Support</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link
                        to="/services/co2-calculation-visualization-service-by-zero-board"
                        >CO2 Calculation & Visualization Service by Zero
                        Board</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/services/technical-troubleshooting"
                        >Technical Troubleshooting</nuxt-link
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/services/logistics-supports"
                        >Logistics Supports</nuxt-link
                      >
                    </li>
                  </template>
                  <hr class="pb-0 d-block d-md-none" />
                </ul>
              </div>
              <div class="col-12 col-md-4">
                <ul>
                  <li class="heading d-flex justify-content-between">
                    <div>Sitemap</div>
                    <div
                      class="d-block d-md-none fs-2 cursor-pointer"
                      @click="showFooterSitemap = !showFooterSitemap"
                    >
                      {{ showFooterSitemap ? "-" : "+" }}
                    </div>
                  </li>
                  <template v-if="!showFooterSitemap">
                    <li class="d-none d-md-block">
                      <nuxt-link to="/terms-conditions">Terms of Use</nuxt-link>
                    </li>
                    <li class="d-none d-md-block">
                      <a
                        href="https://group.nagase.com/th/privacy"
                        target="_blank"
                        >Privacy Policy <i class="fas fa-external-link-alt"></i></a
                      >
                    </li>
                    <li class="d-none d-md-block">
                      <nuxt-link to="/sitemap.xml">Sitemap</nuxt-link>
                    </li>
                  </template>
                  <template v-else>
                    <li class="d-md-block">
                      <nuxt-link to="/terms-conditions">Terms of Use</nuxt-link>
                    </li>
                    <li class="d-md-block">
                      <a
                        href="https://group.nagase.com/th/privacy"
                        target="_blank"
                        >Privacy Policy <i class="fas fa-external-link-alt"></i></a
                      >
                    </li>
                    <li class="d-md-block">
                      <nuxt-link to="/sitemap.xml">Sitemap</nuxt-link>
                    </li>
                  </template>
                  <hr class="pb-0 d-block d-md-none" />
                </ul>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 order-1 order-md-2 d-md-flex">
            <br />
            <div class="vertical-hr d-none d-md-block"></div>
            <div class="row">
              <div class="col-12">
                <ul class="">
                  <li class="heading">Get in Touch</li>
                  <div class="footer-contact">
                    Learn more about our products and services or to request a
                    quote
                  </div>
                  <nuxt-link to="/contact-us" class="btnx contact">
                    Contact Us
                  </nuxt-link>
                </ul>
                <br />
                <br />
                <hr class="d-block d-md-none" />
              </div>
            </div>
          </div>

          <div class="col-12 order-3">
            <br />
            <br />
            <hr class="footer-custom" />
            <div class="row">
              <div class="col-12 col-md-3 p-4 text-center">
                <img class="logo" src="/public/logo-white.svg" />
              </div>
              <div class="col-12 col-md-9">
                <div
                  class="footer d-flex flex-column flex-md-row align-items-center justify-content-end"
                >
                  <span
                    ><a
                      href="https://group.nagase.com/th/privacy"
                      target="_blank"
                      >Privacy Policy <i class="fas fa-external-link-alt"></i></a
                    ></span
                  >
                  <span class="p-2 d-none d-md-block"> | </span>
                  <span
                    ><nuxt-link to="/terms-conditions"
                      >Terms of Use</nuxt-link
                    ></span
                  >

                  <span class="p-2 d-none d-md-block"> | </span>
                  <span
                    ><nuxt-link to="/contact-us">Contact Us</nuxt-link></span
                  >
                </div>
                <div
                  class="d-flex align-items-center justify-content-end flex-column flex-md-row"
                >
                  <span
                    ><a href="https://www.nagase.com/" target="_blank"
                      >NAGASE Group Website <i class="fas fa-external-link-alt"></i></a
                    ></span
                  >
                  <span class="p-2 d-none d-md-block"> | </span>
                  <span
                    ><a href="https://www.nagase.co.jp/english/" target="_blank"
                      >Nagase & Co., Ltd. Corporate Website <i class="fas fa-external-link-alt"></i></a
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-copyright">
      © {{ currentYear }} Nagase (Thailand) Co.,Ltd. All rights reserved.
    </section>
  </footer>
</template>
<script setup>
const currentYear = new Date().getFullYear();
const showFooterAbout = ref(false);
const showFooterProductService = ref(false);
const showFooterSitemap = ref(false);
</script>
